import React, { useCallback, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { globalCmsData } from "@/redux/cms/cmsSelectors";
import {useSelector} from "react-redux"


const Captcha = React.memo(({ setCaptchaError,setIsLoading }) => {
  const pdpGlobalCmsData = useSelector(globalCmsData);
  const str = "6Lex9CIaAAAAADhemTu4p3PC0qRA1kcvGi7rz8R8"

  const handleCaptchaChange = useCallback(
    (value) => {
      setCaptchaError(!value); 
      setIsLoading(!value)
    },
    [setCaptchaError,setIsLoading]
  );

  const handleCaptchaError = useCallback(() => {
    setCaptchaError(true);
    setIsLoading(true)
  }, [setCaptchaError,setIsLoading]);

//   useEffect(() => {
//     if (!str) {
//   setCaptchaError(false);
//   setIsLoading(false); // avoid blocking UI indefinitely
// }
//   }, [str]);

  return (
    <ReCAPTCHA
      id="recaptcha-element"
      sitekey={str}
      onChange={handleCaptchaChange}
      onErrored={handleCaptchaError}
    />
  );
});

export default Captcha;